var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "detarminateForm", attrs: { novalidate: "" } },
        [
          _c("div", { staticClass: "mb-2" }, [
            _c("i", { staticClass: "mr-2 fas fa-file mb-1 text-orange" }),
            _c(
              "label",
              { staticClass: "font-16 color-black font-weight-bold" },
              [_vm._v(" Determinar ")]
            )
          ]),
          _c("div", { staticClass: "font-16 color-black mb-2" }, [
            _vm._v(" Categorías: ")
          ]),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-radio", {
                      staticClass: "custom-radio via",
                      attrs: {
                        "custom-error-msg": "El campo es requerido.",
                        disabled: _vm.determinationCategoryOptions.length === 1,
                        error: !!errors[0],
                        name: "determinationCategory",
                        options: _vm.determinationCategoryOptions
                      },
                      model: {
                        value: _vm.determinationCategory,
                        callback: function($$v) {
                          _vm.determinationCategory = $$v
                        },
                        expression: "determinationCategory"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "rounded p-3 bg-secondary-3 my-3" },
        [
          _c("custom-file-input", {
            key: _vm.documents.length,
            ref: "file",
            attrs: {
              accept: ".pdf",
              "display-style": "normal",
              "on-download": () => {}
            },
            on: { input: _vm.addFile }
          })
        ],
        1
      ),
      _vm._l(_vm.pagination.items, function(item, key) {
        return _c(
          "div",
          { key: item.id, staticClass: "rounded p-3 bg-secondary-3 my-3" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Archivo:")]),
                _c("div", [_vm._v(_vm._s(_vm._f("empty")(item.file.name)))])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end mt-1" },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-times-circle icon-mr-0",
                        variant: "outline-danger mr-2"
                      },
                      on: {
                        click: function($event) {
                          return _vm.remove(key)
                        }
                      }
                    }),
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-file-download icon-mr-0",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.download(item.file)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      }),
      _vm.pagination.totalItemCount > _vm.pagination.pageSize
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": page => (_vm.currentPage = page) }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end align-items-center mt-4" },
        [
          _c("action-button", {
            attrs: {
              i: "fas fa-times-circle",
              text: "Cancelar",
              variant: "outline-danger mr-2"
            },
            on: { click: _vm.cancel }
          }),
          _c("action-button", {
            attrs: { i: "fas fa-save", text: "Guardar", variant: "success" },
            on: { click: _vm.save }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", { staticClass: "mr-2 fas fa-file mb-1 text-orange" }),
      _c("label", { staticClass: "font-16 color-black font-weight-bold" }, [
        _vm._v(" Documentos ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }